import React, { Fragment } from "react";

const SuccessFormSubmitMessage = ({ userData }) => {
  return (
    <Fragment>
      <p>
        Agora acesse o <strong>Unico Auto</strong> usando os dados abaixo.
      </p>
      <p>
        <strong>Usuário:</strong>{" "}
        <strong className="vnUserHighlight">{userData.login}</strong>
      </p>
    </Fragment>
  );
};

export default SuccessFormSubmitMessage;



// WEBPACK FOOTER //
// ./src/components/SuccessFormSubmitMessage.js